import { axiosInstance } from "../utils/axios";

// All HAL unwrapping for the Hall of Fame page stops here — pages and contexts consume plain
// domain objects, never `_embedded`.
export function unwrapCollection(data, relation) {
  if (Array.isArray(data)) return data;
  if (data && data._embedded && Array.isArray(data._embedded[relation])) {
    return data._embedded[relation];
  }
  return [];
}

export async function fetchBoards(group, simulatorId) {
  const { data } = await axiosInstance.get("/records/boards", {
    params: { group, simulator: simulatorId },
  });
  return unwrapCollection(data, "boards");
}

export async function fetchBoard(kind, simulatorId) {
  const { data } = await axiosInstance.get(`/records/boards/${kind}`, {
    params: { simulator: simulatorId },
  });
  return data;
}

export async function fetchTracks(simulatorId) {
  const { data } = await axiosInstance.get("/records/tracks", {
    params: { simulator: simulatorId },
  });
  return unwrapCollection(data, "tracks");
}

export async function fetchChampions(simulatorId) {
  const { data } = await axiosInstance.get("/records/champions", {
    params: { simulator: simulatorId },
  });
  return unwrapCollection(data, "champions").map((row) => ({
    ...row,
    team: { name: row.teamName, color: row.teamColor },
  }));
}
